module.exports = __webpack_public_path__ + "static/media/Reportage.ea627e34.mp4";